import { render, staticRenderFns } from "./LayerWidget.vue?vue&type=template&id=2de904f4&scoped=true"
import script from "./LayerWidget.vue?vue&type=script&lang=js"
export * from "./LayerWidget.vue?vue&type=script&lang=js"
import style0 from "./LayerWidget.vue?vue&type=style&index=0&id=2de904f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de904f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de904f4')) {
      api.createRecord('2de904f4', component.options)
    } else {
      api.reload('2de904f4', component.options)
    }
    module.hot.accept("./LayerWidget.vue?vue&type=template&id=2de904f4&scoped=true", function () {
      api.rerender('2de904f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/LayerWidget.vue"
export default component.exports